import type { UserTypes } from "@hub/common-libs";
import { RoleDetails } from "@interfaces/api/user.service.model";
import { SelectOption } from "@ucchub/ui";

export interface UserManagementServiceResponse
  extends UserTypes.ServiceResponse {
  data: UserManagementData;
}

export interface UserManagementData {
  message: string;
  status: string;
  failed?: FailedUserManagementData[];
}
export interface FailedUserManagementData {
  message: string;
  email: string;
}
export enum UserStatus {
  ACTIVE = "active",
  DELETED = "deleted",
  INACTIVE = "inactive",
}

export type FilterValues = {
  status?: UserStatus | undefined;
  orgId?: string;
  role?: RoleDetails | undefined;
};

export type FilterData = {
  status?: SelectOption;
  organisation?: SelectOption;
  roleId?: SelectOption;
};
